import axios from 'axios'


/****************************************************************************
****** Get Error Message From Response For Pay Invoice With Reference. ******
*****************************************************************************/


export const getErrorFromFailResponse = (error) => {
  let returnedData = null;
  if (axios.isCancel(error)) {
    const response = {};
    response.data = {};
    response.data.errors = [];
    response.data.errors[0] = {
      details: "Response Cancelled",
    };
    returnedData = response;
    return returnedData;
  }
  let { response } = error;

  if (response && response.status) {
    if (response.status === 400) {
      const { data } = response;
      const { code } = data;
      switch (code) {
        case "ERR_INVOICE_NOT_FOUND":
          response.data.errors = [];
          response.data.errors[0] = {
            details: "Unfortunately, we were unable to find a matching invoice in our system. Please review the invoice number you entered and try again. If you believe this is an error please contact our Accounts & Billing team via your VIPControl account or over the phone on 13 24 85.",
          };
          break;

        case "ERR_INVOICE_PAID":
          response.data.errors = [];
          response.data.errors[0] = {
            details: "Our system indicates this invoice is already paid in full, if you believe this is not the case please contact our Accounts & Billing team via your VIPControl account or over the phone on 13 24 85 for further investigation.",
          };
          break;

        case "ERR_ACCOUNT_INVALID":
          response.data.errors = [];
          response.data.errors[0] = {
            details: "Invoice does not belong to an account.",
          };
          break;

        case "ERR_INVALID_INPUT":
          response.data.errors = [];
          response.data.errors[0] = {
            details: "Postcode does not match invoice details.",
          };
          break;

        case "ERR_INVALID_SIGNATURE":
          response.data.errors = [];
          response.data.errors[0] = {
            details:
              "Invalid signature to pay invoice. Please try again later or contact our support team.",
          };
          break;

        case "ERR_INVOICE_CANCELLED":
          response.data.errors = [];
          response.data.errors[0] = {
            details: "Our system indicates this invoice is cancelled, this could be due to service(s) within this invoice being cancelled either by request of the account holder or due to being overdue for an extended period of time. For more information, please contact our Accounts & Billing team via your VIPControl account or over the phone on 13 24 85.",
          };
          break;

        default:
          if (!response.data.errors[0].details) {
            response.data.errors = [];
            response.data.errors[0] = {
              details:
                "Something's gone wrong. Please try again later or contact our support team.",
            };
          }
          break;
      }
      returnedData = response;
    }
    return returnedData
  }

};
